var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nup-btn",class:[
    ("nup-btn--" + _vm.variant),
    _vm.block ? 'nup-btn--block' : '',
    _vm.disabled ? 'nup-btn--disabled' : '' ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }